// extracted by mini-css-extract-plugin
export default {"wrongDepth":"CorrectDepth_wrongDepth__qVwbO","acceptableDepth":"CorrectDepth_acceptableDepth__zy2HB"};